/**
 * Generates a 6-character uppercase alphanumeric referral code from a user's UID.
 * Since UIDs are unique, the derived code is unique per user.
 */
export default function generateReferralCode(uid) {
    return uid.slice(-6).toUpperCase();
}
